module.exports = "/packs/media/modules/welcome/assets/hero-7541edbb394d9fae0cfabd7b30b65e02.jpg";